import { Schema } from 'normalizr';

import SingletonDuckEntity from './SingletonDuckEntity';

const entity = new SingletonDuckEntity(
  'blackbaudSkyConfig', { schema: new Schema('blackbaudSkyConfig') }
);

export { entity as blackbaudSkyConfig };